export const STOP_LOADING = 'STOP_LOADING'
export const START_LOADING = 'START_LOADING'



// WEBPACK FOOTER //
// ./src/types/loading.js